var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencil = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#dedede;}.b{fill:#dedede;fill-rule:evenodd;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 26,
    height: 26,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M120.3,840.411l-7.227,7.309-1,4.6a1.386,1.386,0,0,0,1.65,1.65l4.6-1,7.237-7.321a1.388,1.388,0,0,0-.006-1.956l-3.284-3.284A1.387,1.387,0,0,0,120.3,840.411Zm-5.491,12.053-1.234-1.233.63-2.893,3.5,3.5Z",
    transform: "translate(-105.042 -833.999)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNiIgaGVpZ2h0PSIyNiIgdmlld0JveD0iMCAwIDI2IDI2Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmZmO3N0cm9rZTojZGVkZWRlO30uYntmaWxsOiNkZWRlZGU7ZmlsbC1ydWxlOmV2ZW5vZGQ7fS5je3N0cm9rZTpub25lO30uZHtmaWxsOm5vbmU7fTwvc3R5bGU+PC9kZWZzPjxnIGNsYXNzPSJhIj48cmVjdCBjbGFzcz0iYyIgd2lkdGg9IjI2IiBoZWlnaHQ9IjI2IiByeD0iMiIvPjxyZWN0IGNsYXNzPSJkIiB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjI1IiBoZWlnaHQ9IjI1IiByeD0iMS41Ii8+PC9nPjxwYXRoIGNsYXNzPSJiIiBkPSJNMTIwLjMsODQwLjQxMWwtNy4yMjcsNy4zMDktMSw0LjZhMS4zODYsMS4zODYsMCwwLDAsMS42NSwxLjY1bDQuNi0xLDcuMjM3LTcuMzIxYTEuMzg4LDEuMzg4LDAsMCwwLS4wMDYtMS45NTZsLTMuMjg0LTMuMjg0QTEuMzg3LDEuMzg3LDAsMCwwLDEyMC4zLDg0MC40MTFabS01LjQ5MSwxMi4wNTMtMS4yMzQtMS4yMzMuNjMtMi44OTMsMy41LDMuNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMDUuMDQyIC04MzMuOTk5KSIvPjwvc3ZnPg==";